module.exports = __webpack_public_path__ + "img/circle2.603f43c2.png";